export default "/WebApp/dist/assets/images/maths.jpg";